import Keycloak from "keycloak-js"

const keycloakInstance = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_ENDPOINT,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
})

export default keycloakInstance
